export default "__VITE_ASSET__e9360cd0__"